module.exports = __webpack_public_path__ + "img/ICICI_InstaOD_Banners.435de185.jpg";